<template>
  <div class="wrapper">
    <div class="left_contain">
      <div class="font_16_sold" style="margin-top:24px;margin-bottom:10px">告警信息</div>
      <div class="left_normal_contain" style=" border-bottom: 1px solid rgba(0, 0, 0, 0.09);">
        <span class="left_normal_item" v-for="(item, index) in alarmArray" :key="index">{{
          item
        }}</span>
      </div>
      <div class="font_16_sold" style="margin-top:24px;margin-bottom:10px">字段库</div>
      <div class="left_normal_contain">
        <span class="left_normal_item" v-for="(item, index) in fieldArray" :key="index">{{
          item
        }}</span>
      </div>
    </div>
    <div class="middle_contain">
      <div class="middle_top_contain">
        <el-button type="text">预览</el-button>
        <el-button type="primary" @click="saveMenthod">保存</el-button>
        <el-button @click="cancleMenthod">取消</el-button>
      </div>
      <el-form
        label-position="top"
        label-width="80px"
        style="width:400px;margin-top:29px;margin-left:27px"
        class="custom-form"
      >
        <el-form-item label="违规人" required>
          <el-input
            v-model="violationPersonname"
            placeholder="请输入"
            suffix-icon="el-icon-tickets"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="说明">
          <el-input type="textarea" placeholder="请输入说明" v-model="desc"></el-input>
        </el-form-item>
        <el-form-item label="处罚类型" required>
          <el-select v-model="punishType" placeholder="请选择">
            <el-option label="类型一" value="1"></el-option>
            <el-option label="类型二" value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="bottom_contain">
      <div class="right_top_contain">
        <div class="font_16_sold">字段属性</div>
      </div>
      <el-form
        label-position="top"
        label-width="80px"
        style="width:227px;margin-top:29px;margin-left:27px"
        class="custom-form"
      >
        <el-form-item label="标识名" required>
          <el-input v-model="identifyName" placeholder="请输入" suffix-icon="el-icon-tickets">
          </el-input>
        </el-form-item>
        <el-form-item label="提示文字">
          <el-input
            type="textarea"
            placeholder="显示在标识名右侧的说明文字"
            v-model="remindWord"
          ></el-input>
        </el-form-item>
        <el-form-item>
          选项设置
        </el-form-item>
        <el-form-item v-for="(item, index) in optionArray" :key="index">
          <div class="flex_start_center">
            <el-radio v-model="item.boxIscheck" style="margin-right:0px"> </el-radio>
            <el-select v-model="item.selectOption" placeholder="请选择">
              <el-option
                v-for="(sonitem, sonindex) in options"
                :key="sonindex"
                :label="sonitem"
                :value="sonitem"
              ></el-option>
            </el-select>
            <img
              class="delete_image"
              src="../../../../assets/img/delete-s.png"
              @click="deleteOptionMenthod(index)"
            />
          </div>
        </el-form-item>
        <el-form-item>
          <el-button
            type="text"
            icon="el-icon-plus"
            style="padding-left:0px"
            @click="addoptionMenthod"
            >添加选项</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-checkbox v-model="isRequired">设为必填</el-checkbox>
        </el-form-item>
        <el-form-item label="填写人" required>
          <el-select v-model="fillName" placeholder="请选择">
            <el-option label="第一级处理人" value="1"></el-option>
            <el-option label="第二级处理人" value="2"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      violationPersonname: '', //违规人
      desc: '', //说明
      punishType: '', //处罚类型
      identifyName: '', //标识名
      remindWord: '', //提醒文字
      fillName: '', //填写人
      isRequired: false, //是否必填项
      alarmArray: ['监控点位', '告警类型', '告警时间', '告警截图', '告警视频'],
      fieldArray: [
        '单行文本',
        '多行文本',
        '下拉框',
        '多选',
        '日期时间',
        '日期',
        '人员选择',
        '附件'
      ],
      options: ['选项1', '选项2', '选项3', '选项4'],
      optionArray: [
        {
          boxIscheck: false,
          selectOption: ''
        }
      ]
    };
  },
  methods: {
    addoptionMenthod() {
      let paragram = {
        boxIscheck: false,
        selectOption: ''
      };
      this.optionArray.push(paragram);
    },

    deleteOptionMenthod(index) {
      this.optionArray.splice(index, 1);
    },

    saveMenthod() {
      console.log(JSON.stringify(this.optionArray));
      this.$router.back(-1);
    },

    cancleMenthod() {
      this.$router.back(-1);
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  height: 100%;
  overflow: hidden;
  display: flex;
  background: white;
}

.left_contain {
  width: 25%;
  padding-left: 30px;
  padding-right: 30px;
}

.middle_contain {
  width: 50%;
  border-left: 1px solid rgba(0, 0, 0, 0.09);
  border-right: 1px solid rgba(0, 0, 0, 0.09);
}

.bottom_contain {
  width: 25%;
}

.left_normal_contain {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-bottom: 32px;
}

.left_normal_item {
  background: #ebf3fe;
  width: 80px;
  height: 40px;
  line-height: 40px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  text-align: center;
  margin-top: 15px;
}

.font_16_sold {
  font-size: 16px;
  font-weight: bold;
  color: rgba(0, 0, 0, 1);
}

.middle_top_contain {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  border-bottom: 1px solid rgba(0, 0, 0, 0.09);
  padding-right: 25px;
}

.right_top_contain {
  height: 60px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(0, 0, 0, 0.09);
  padding-left: 25px;
}

.delete_image {
  width: 18px;
  height: 18px;
  margin-left: 10px;
  cursor: pointer;
}

.flex_start_center {
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
}
</style>
